// Book-industry-standard Terms & Privacy for a publisher / author newsletter site
// (collects email for marketing, links out to third-party retailers and merch).

export const TERMS_CONTENT = {
  effective: "January 1, 2026",
  sections: [
    {
      heading: "1. Acceptance of Terms",
      paragraphs: [
        "Welcome to AiPresidential.com (the \"Site\"), operated by Victor M. Medina (\"we,\" \"us,\" \"our\"). By accessing or using the Site, you agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree, please do not use the Site.",
      ],
    },
    {
      heading: "2. About the Content",
      paragraphs: [
        "The Site promotes the AiPresidential trilogy of novels (COGNITO, ECHO, TIMELESS) and related materials including excerpts, author commentary, newsletter posts, reviews, and merchandise. All written work, cover art, character names, and original images on the Site are protected by copyright and trademark law and are the property of the author, except where third-party content is clearly credited.",
        "Excerpts and previews are provided for personal, non-commercial reading only. You may not reproduce, redistribute, adapt, perform, or create derivative works from any content on the Site without prior written permission from the author or publisher.",
      ],
    },
    {
      heading: "3. Newsletter & Email Sign-up",
      paragraphs: [
        "By submitting your email address, you consent to receive launch announcements, excerpt previews, behind-the-scenes content, and occasional offers related to the AiPresidential trilogy. You may unsubscribe at any time using the link in any email we send you, or by contacting AiPresidential2026@gmail.com.",
      ],
    },
    {
      heading: "4. Third-Party Retailers & Affiliate Links",
      paragraphs: [
        "Links to Amazon, Apple Books, Google Books, Barnes & Noble, Audible, and other retailers are provided for your convenience. Any purchase made through those links is governed by the third party's own terms and privacy policy. We may earn an affiliate commission on qualifying purchases at no additional cost to you.",
      ],
    },
    {
      heading: "5. Merchandise (Print-on-Demand)",
      paragraphs: [
        "Physical and apparel merchandise is fulfilled by our print-on-demand partner (Printful). Orders, shipping, returns, and refunds for those items are processed and supported by the fulfillment partner under their policies. Product photos are illustrative; minor variation in color and finish may occur.",
      ],
    },
    {
      heading: "6. User-Submitted Content",
      paragraphs: [
        "If you submit feedback, reviews, or comments, you grant us a non-exclusive, royalty-free, worldwide license to use, display, and quote that content (with attribution as provided) for promotional purposes related to the trilogy. You represent that you own or have the rights to anything you submit.",
      ],
    },
    {
      heading: "7. Pre-orders & Release Dates",
      paragraphs: [
        "Cover art, release dates, prices, and product details shown on the Site are subject to change prior to publication. We will use reasonable efforts to keep this information accurate but make no warranty that any specific release date will be met.",
      ],
    },
    {
      heading: "8. Disclaimer & Limitation of Liability",
      paragraphs: [
        "The Site and its content are provided \"as is\" without warranty of any kind. The AiPresidential trilogy is a work of fiction; characters, organizations, technology, and events are products of the author's imagination and any resemblance to real persons or institutions is coincidental.",
        "To the fullest extent permitted by law, the author, publisher, and operators of the Site are not liable for any indirect, incidental, or consequential damages arising from your use of the Site.",
      ],
    },
    {
      heading: "9. Governing Law",
      paragraphs: [
        "These Terms are governed by the laws of the United States and the State of California, without regard to its conflict-of-laws rules. Any dispute will be resolved exclusively in the state or federal courts located in that jurisdiction.",
      ],
    },
    {
      heading: "10. Contact",
      paragraphs: [
        "Questions about these Terms? Email AiPresidential2026@gmail.com.",
      ],
    },
  ],
};

export const PRIVACY_CONTENT = {
  effective: "January 1, 2026",
  sections: [
    {
      heading: "1. What We Collect",
      paragraphs: [
        "Email address and (optionally) the name you provide when you sign up for our newsletter. Standard server logs (IP address, browser type, referrer, pages viewed) for security and analytics. Information you submit when contacting us or leaving a review.",
      ],
    },
    {
      heading: "2. How We Use Your Information",
      paragraphs: [
        "To send you launch announcements, excerpt previews, author updates, and occasional promotional offers about the AiPresidential trilogy. To respond to inquiries and improve the Site. To detect and prevent abuse.",
        "We do not sell your personal information. We do not share your email address with third parties except with the service providers strictly necessary to deliver email (see Section 3).",
      ],
    },
    {
      heading: "3. Service Providers We Use",
      paragraphs: [
        "Mailchimp (Intuit, Inc.) — newsletter delivery and list management.",
        "Printful — print-on-demand fulfillment if you purchase merchandise; they collect shipping and payment information directly under their own privacy policy.",
        "Retailers (Amazon, Apple Books, Google Books, Barnes & Noble, Audible, etc.) — if you click a buy link, the transaction takes place on their site under their terms and privacy policies.",
      ],
    },
    {
      heading: "4. Cookies & Tracking",
      paragraphs: [
        "We use minimal first-party storage (local/session storage) to remember whether you've already subscribed and to avoid showing the exit-intent reminder twice. We do not use cross-site advertising trackers. Affiliate links to retailers may set their own cookies once you click through.",
      ],
    },
    {
      heading: "5. Your Choices & Rights",
      paragraphs: [
        "You can unsubscribe from emails at any time using the link in any email or by contacting AiPresidential2026@gmail.com. You can ask us to access, correct, or delete the personal information we hold about you. Residents of California (CCPA), the EU/UK (GDPR), and similar jurisdictions have additional rights, including the right to data portability and to lodge a complaint with a supervisory authority.",
      ],
    },
    {
      heading: "6. Data Retention",
      paragraphs: [
        "We retain your email and signup record for as long as you remain subscribed plus a reasonable period for our records. We delete or anonymize personal data when it is no longer needed for the purpose it was collected.",
      ],
    },
    {
      heading: "7. Children",
      paragraphs: [
        "The Site is not directed to children under 13, and we do not knowingly collect personal information from them. If you believe a child has provided us information, please contact us and we will delete it.",
      ],
    },
    {
      heading: "8. Security",
      paragraphs: [
        "We use industry-standard safeguards (TLS in transit, access controls) to protect your information. No method of transmission or storage is 100% secure; you provide your information at your own risk.",
      ],
    },
    {
      heading: "9. Changes",
      paragraphs: [
        "We may update this Privacy Policy from time to time. Material changes will be noted on this page with a new effective date.",
      ],
    },
    {
      heading: "10. Contact",
      paragraphs: [
        "Privacy questions or requests: AiPresidential2026@gmail.com.",
      ],
    },
  ],
};
